export default __webpack_public_path__ + "static/media/aboutUs-Artwork.bcdc512a.svg";